import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useContext } from "react";
import { getLink, sendCallToAPI } from "../../../common/generic_functions";
import { links } from "../links";
import { FormLoginWrapper } from "./wrappers";
import { AlertContext } from "../login";
import "../login.sass";
import { handleKeyDownTab } from "./forms";

export const ResetPassword = ({ isTokenAvailable, handleBackClick, email, purpose, LoginContext }) => {
  const { setMessageProps, setLoading } = useContext(LoginContext);
  const methods = useForm({ mode: "onChange" });
  const { errors } = methods.formState;
  const { enableAlert } = useContext(AlertContext);
  const onSubmit = (data) => resetPassword(data, email);
  const newPassword = methods.watch("newPassword") || "";

  const resetPassword = async (data, email) => {
    const link = getLink("", links, "update-password");
    let result;
    let messageProps = {};
    data["email"] = email;
    data["code"] = isTokenAvailable;
    data["purpose"] = purpose;
    try {
      result = await sendCallToAPI(link, "notoken", data, "POST");
      if (result?.message && result?.reset === true) {
        handleBackClick();
        messageProps = { type: "success", text: "Password changed successfully! please login with new credentials" };
      }
      else{
         messageProps = { type: "danger", text: "Sorry, an unexpected error has occurred!" };
      }
    } catch (e) {
      messageProps = e.messageType ? e : { type: "danger", text: "Sorry, an unexpected error has occurred!" };
    } finally {
      enableAlert(messageProps);
      setLoading(false);
    }
  };

  const checks = {
    length: newPassword.length >= 10,
    uppercase: /[A-Z]/.test(newPassword),
    number: /\d/.test(newPassword),
    special: /[!@#$%^&*]+/.test(newPassword),
  };

  const checkList = (
    <ul className="password-checklist">
      <li className={checks.length ? "valid" : "invalid"}>10 characters at least </li>
      <li className={checks.uppercase ? "valid" : "invalid"}>1x uppercase letter</li>
      <li className={checks.number ? "valid" : "invalid"}>1x number</li>
      <li className={checks.special ? "valid" : "invalid"}>1x special character</li>
    </ul>
  );

  const isNewPasswordValid =
      checks.length &&
      checks.uppercase &&
      checks.number &&
      checks.special ? true : false

  const getStrength = (password) => {
    if (password.length >= 15) return "strong";
    if (password.length >= 10) return "medium";
    return "weak";
  };

  const strength = getStrength(newPassword);
  return (
    <FormLoginWrapper
      onSubmit={onSubmit}
      methods={methods}
      purpose={purpose}
      LoginContext={LoginContext}
      list={checkList}
      isNewPasswordValid={isNewPasswordValid}
      enableAlert={enableAlert}
      text={"Reset your password"}
    >
      <div>
        <Form.Control
          type="text"
          style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
          value={email}
          disabled={true}
        />
        <div style={{ paddingBottom: "5px" }}></div>
        {purpose === "register" && (
          <>
            <Form.Control
              type="text"
              id="reset-first"
              style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
              placeholder="First name"
              required
              {...methods.register("firstName")}
            />
            <div style={{ paddingBottom: "5px" }}></div>
            <Form.Control
              type="text"
              style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
              placeholder="Last name"
              required
              {...methods.register("lastName")}
            />
            <div style={{ paddingBottom: "5px" }}></div>
          </>
        )}
        <Form.Control
          type="password"
          id="reset-first"
          style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
          placeholder="New password"
          required
          {...methods.register("newPassword")}
        />
        {newPassword.length > 0 && <Form.Text className={`strength ${strength}`}>Password strength {strength}</Form.Text>}
        <div style={{ paddingBottom: "5px" }}></div>
        <Form.Control
          type="password"
          style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
          placeholder="Confirm new password"
          isInvalid={!!errors.confirmPassword}
          {...methods.register("confirmPassword", {
            required: "Confirm Password is required",
            validate: (value) => value === methods.watch("newPassword") || "Confirm password do not match",
          })}
          onKeyDown={(e) => handleKeyDownTab(e, "reset-first")}
        />
        {errors.confirmPassword && (
          <Form.Control.Feedback className={"strength"} type="invalid">
            {errors.confirmPassword?.message}
          </Form.Control.Feedback>
        )}
      </div>
    </FormLoginWrapper>
  );
};
